// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  loginPortal: 'PROVIDER_PORTAL',
  apiBaseUrl: 'https://uatproviderapi.ewatpa.com',
  mdpApiBaseUrl: 'http://65.0.196.93:5003',
  mdpPassword: 'volo_test',
  // TODO: replace with the real OCR and temp-upload base URLs
  ocrApiBaseUrl: 'https://decisioning.uat.volotpa.in',
  ocrApiKey: 'secret',
  ocrTenantId: 'payvider',
  apiEnrolUrl: "https://uatapiconsumer.ewatpa.com",
  apiClaimsUrl: "https://uatapiclaims.ewatpa.com",
  apiAdminUrl: 'https://uatapiadmin.ewatpa.com',
  bucket_tariff: 'prod-ewa-tariffs',
  bucket_member:'prod-ewa-member-management',
  misReportsBucket: 'uat-ewa-mis-reports',
  vcnBaseUrl: 'https://uatppmcapi.ewatpa.co.in',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
